export default "__VITE_ASSET__CASGYQRc__"